import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker/models';
import { AddleavetypepopupComponent } from '../../generalpopup/addleavetypepopup/addleavetypepopup.component';
import { ComponentCanDeactivate } from '../../PendingChangesGuard ';
import { ApprovepopComponent } from '../../grid/approvepop/approvepop.component';
import { AttachmentComponent } from '../../grid/attachment/attachment.component';
import { LeaveoptionpopupComponent } from '../leaveoptionpopup/leaveoptionpopup.component';
import { CancelleavepopupComponent } from '../cancelleavepopup/cancelleavepopup.component';

@Component({
  selector: 'app-addleave',
  templateUrl: './addleave.component.html',
  styleUrls: ['./addleave.component.css']
})
export class AddleaveComponent implements OnInit, ComponentCanDeactivate {
  @ViewChild('approvebar', { static: false }) approvebar;
  @ViewChild('attachmentbar', { static: false }) attachmentbar;

  formname: string = "LEAVE";


  //Display
  formmode: string = "Add";
  rtnform: string = "";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isapprovemode: boolean = false;
  isrejectmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  isshowattachment: boolean = false;
  attachmentcount: number = 0;

  isshowapproval: boolean = false;

  isapprove: boolean = false;
  isreject: boolean = false;

  ismanualclose: boolean;

  isemploading: boolean=false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  //Edit Get Values
  leaveColl: any = [];
  leaveid: number = 0
  leaveBO: any = {}


  leavetypeColl: any = [];
  empColl: any = [];
  empBO: any = {}

  diffInDays: any = ""
  
  leavehistroyBO:any={}
  leavehistroyColl: any = [];

  leaveform = new FormGroup({
    leaveid: new FormControl(0),
    empid: new FormControl(null, Validators.required),
    leavetypeid: new FormControl(null, Validators.required),
    transdt: new FormControl(null, Validators.required),
    startdt: new FormControl(null, Validators.required),
    enddt: new FormControl(null, Validators.required),
    descr: new FormControl(''),
    inactive: new FormControl(false),
  });

  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal, private datePipe: DatePipe) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.leaveid = params.id
      }


      if (params.rtnform !== undefined) {
        this.rtnform = params.rtnform
      }

    });

    this.fnServiceChanges();
    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
  }


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.leaveform.reset();
      this.fnInitializeFormGroup();

      if (this.leaveid > 0) {
        this.fngetLeave();
      }

      this.fngetEmployee();

      this.fnCalculateFromToDateDiff();

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.leaveid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    
    this.isapprovemode = this.loginService.fnCheckUserRoleAction(this.formname, 'APPROVE')
    this.isrejectmode = this.loginService.fnCheckUserRoleAction(this.formname, 'REJECT')

    
    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  fnInitializeFormGroup() {
    this.leaveform.setValue({
      leaveid: 0,
      empid: null,
      leavetypeid: null,
      startdt: new Date(),
      transdt: new Date(),
      descr: '',
      enddt: new Date(),
      inactive: false
    })
  }

  fngetEmployee() {
    this.isemploading=true;

    var data = {
      'empid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          this.isemploading=false;
          if (res.json().status === 200) {
            this.empColl = res.json().result;
            this.fnChangeEmpLookup();
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.isemploading=false;
          this.toastr.error('Error', err);
        })
  }


  //Get 
  fngetLeave() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'leaveid': this.leaveid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getLeave(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.leaveColl = res.json().result;
            var editdata = this.leaveColl[0];
            this.leaveBO = editdata;
            this.fnEditMode(editdata);
          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }

  fngetLeaveHistory() {

    var empid = this.leaveform.get('empid').value;

    if (empid > 0) {
      var data = {
        'empid': empid,
        'companyid': this.loginService.fnGetCompanyId()
      }
      this.appService.getLeave(data)
        .subscribe(
          (res) => {
            if (res.json().status === 200) {
              this.leavehistroyColl = res.json().result;

            }
            else {
              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => {
            this.toastr.error('Error', err);
          })


      this.fngetLeaveType();
    }
    else {
      this.leavehistroyColl = [];
    }

  }


  fngetLeaveType() {

    var empid = this.leaveform.get('empid').value;

    if (empid > 0) {
      var data = {
        'empid': empid,
        'companyid': this.loginService.fnGetCompanyId()
      }
      this.appService.getLeaveTypeByEmpid(data)
        .subscribe(
          (res) => {
            
            if (res.json().status === 200) {
              var result=res.json().result;
              console.log(result)
              this.leavetypeColl = result[0];

             
              if (result.length > 1) {
                this.leavehistroyBO=result[1][0]
              }

              this.fngetLeaveHistory();
             
            }
            else {
              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => {
            this.toastr.error('Error', err);
          })

    }
    else {
      this.leavetypeColl = [];
      this.leavehistroyBO={}
    }

  }

    
  fnChangeLeaveType() {
    
    this.leavehistroyBO = {};

    for (let abo of this.leavetypeColl) {
      if (abo.leavetypeid == this.leaveform.get("leavetypeid").value) {
        this.leavehistroyBO=abo
      }
    }

  }

  
  fnChangeEmpLookup() {
    var empid = 0;

    empid = this.leaveform.get("empid").value;

    if (empid > 0) {
      for (let abo of this.empColl) {
        if (abo.empid === empid) {
          this.empBO = abo;
        }
      }

    }
    else {
      this.empBO = {};
    }


  }

  fnCalculateFromToDateDiff() {
     let firstDate=this.leaveform.get("startdt").value
    let secondDate = this.leaveform.get("enddt").value
    
    this.diffInDays = Math.floor(Math.abs(<any>firstDate - <any>secondDate) / (1000*60*60*24)) +1;
   // this.diffInDays = Math.abs(firstDate.diff(secondDate, 'days')); 

  }

  
  fnResetValidation() { 

    if (this.loginService.fnCheckFornControlNotfound(this.leaveform.get('enddt'))) {
      this.leaveform.controls['enddt'].setErrors(null);
    }

    
    if (this.loginService.fnCheckFornControlNotfound(this.leaveform.get('startdt'))) {
      this.leaveform.controls['startdt'].setErrors(null);
    }

    if (this.loginService.fnCheckFornControlNotfound(this.leaveform.get('leavetypeid'))) {
      this.leaveform.controls['leavetypeid'].setErrors(null);
    }
    

  }

  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;

      this.fnResetValidation();
      //Validate
      if (this.leaveform.valid) {
        this.saveloading = true;


        //Check
        var data = {
          'leaveid': this.leaveid,
          'startdt': this.fnFormatDatetime(this.leaveform.get('startdt').value),
          'transdt': this.fnFormatDatetime(this.leaveform.get('transdt').value),
          'enddt': this.fnFormatDatetime(this.leaveform.get('enddt').value),
          'empid': this.leaveform.get('empid').value,
          'leavetypeid': this.leaveform.get('leavetypeid').value,
          'descr': this.leaveform.get('descr').value,
          'inactive': this.leaveform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        this.appService.checkLeave(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresult = res.json().result[0].checkfield;

              if (_checkresult === "done") {
                if (this.leaveform.get('leaveid').value > 0) {
                  //Update 
                  this.fnSetLeave(data);
                }
                else {
                  //Insert 
                  this.fnInsertLeave(data);
                }
              }
              else {
                this.saveloading = false;

                if (_checkresult === "date") {
                  this.leaveform.controls['enddt'].setErrors({ 'notfound': true });
                }
                else if (_checkresult === "exist") {
                  this.leaveform.controls['startdt'].setErrors({ 'notfound': true });
                }
                else if (_checkresult === "restrict") {
                  this.leaveform.controls['leavetypeid'].setErrors({ 'notfound': true });
                }
              }
            }
            else {
              this.saveloading = false;

              this.loginService.fnAPIError(res.json())
            }

          },
          (err) => {
            this.saveloading = false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertLeave(data) {

    this.appService.fnInsertLeave(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The new leave has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, this.fngetDescriptionRefno(data));
            this.ismanualclose = true;
            this.fnCloseForm();
            // var _result = res.json().result;

            // if (_result.length > 0) {
            //   var resdata = _result[0];
            //   if (resdata.length > 0) {
            //     this.fnAttachmentSave(resdata[0].leaveid);
            //   }
            // }
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetLeave(data) {

    this.appService.fnSetLeave(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The leave has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.leaveid, this.fngetDescriptionRefno(data));
            this.ismanualclose = true;
            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  fnEmployeeSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.empname.toLocaleLowerCase().indexOf(term) > -1 ||
      item.staffcode.toLocaleLowerCase().indexOf(term) > -1;
  }
//AddExpenseType
private fnAddLeaveOption() {

  const modalRef = this.productFindService.open(LeaveoptionpopupComponent, { size: <any>'l' });

  modalRef.componentInstance.leaveid = this.leaveBO.leaveid;

  modalRef.componentInstance.returndt =  this.fnConvertDatetime(this.fnFormatDatetime(this.leaveBO.returndt));
  modalRef.componentInstance.returncommends = this.leaveBO.returncommends;

   modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      if (receivedEntry === "DONE") {
        this.fngetLeave();
      }

    });
}
//AddExpenseType
private fnAddLeaveCancel() {

  const modalRef = this.productFindService.open(CancelleavepopupComponent, { size: <any>'l' });

  modalRef.componentInstance.leaveid = this.leaveBO.leaveid;

  modalRef.componentInstance.iscancelled =  this.leaveBO.iscancelled;
  modalRef.componentInstance.cancelleddesc = this.leaveBO.cancelleddesc;

   modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      if (receivedEntry === "DONE") {
        this.fngetLeave();
      }

    });
}
  //AddExpenseType
  private fnAddLeaveType() {

    const modalRef = this.productFindService.open(AddleavetypepopupComponent, { size: <any>'l' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetLeaveType();

      if (receivedEntry > 0) {
        //this.leaveform.patchValue({leavetypeid:receivedEntry})
      }
    });

  }
  //Close
  async fnCloseForm() {
    try {
      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;

      if (this.rtnform !== '') {
        this.router.navigate(['/' + this.rtnform]);
      }
      else {
       
        this.router.navigate(['/Leave']);
      }


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  private fnEditMode(deptBO) {

    deptBO.transdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.transdt));


    deptBO.startdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.startdt));
    deptBO.enddt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.enddt));

    this.leaveform.setValue({
      leaveid: deptBO.leaveid,
      empid: deptBO.empid,
      leavetypeid: deptBO.leavetypeid,
      startdt: deptBO.startdt,
      transdt: deptBO.transdt,
      descr: deptBO.descr,
      enddt: deptBO.enddt,
      inactive: deptBO.inactive
    });


    this.formmode = "";

    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;

    this.fnVisibilityApproveStatus();

    this.fngetLeaveHistory();

    this.fnChangeEmpLookup();

    this.fnGetAttachmentCount();
  }


  //Approvals
  fnApproveBtnClick(type) {


    // this.approvebar.formtype = type;    
    // this.approvebar.fnInitializeFormGroup();
    // this.approvebar.fnGetApproveForms();

    this.isshowapproval = !this.isshowapproval

  }

  fnCloseApproveBtnClick(data) {
    this.isshowapproval = !this.isshowapproval

    if (data === 'DONE') {
      this.fngetLeave();
    }

  }

  fnVisibilityApproveStatus() {

    this.isapprove = false;
    this.isreject = false;

    if (this.leaveBO.approvedstatus !== '') {
      if (this.leaveBO.approvedstatus === 'Approve') {
        this.isreject = true;
      }
      else if (this.leaveBO.approvedstatus === 'Reject') {
        this.isapprove = true;
      }
    }
    else {
      this.isapprove = true;
      this.isreject = true;
    }

  }

  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }

  //#Attachment
  fnAttachmentBtnClick() {


    const modalRef = this.productFindService.open(AttachmentComponent, { size: <any>'xxxl' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.trxid = this.leaveid;
    modalRef.componentInstance.formmode = "EDIT";
    modalRef.componentInstance.fnGetAttachment();


    modalRef.result.then(() => {
      this.fnGetAttachmentCount()
    }, () => {
      this.fnGetAttachmentCount()
    })

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      if (receivedEntry === 'DONE') {
        this.fngetLeave();
      }
    });
    
  }


  fnAttachmentSave(tid) {

    if (this.attachmentcount > 0) {

      this.attachmentbar.formtype = this.formname;
      this.attachmentbar.trxid = tid;
      this.attachmentbar.formmode = "ADD";

      this.attachmentbar.fnSaveAttachmentByAddMode();
    }
    else {
      this.fnCloseForm();
    }

  }

  fnSetAttachmentCount(data) {

    this.attachmentcount = data;
  }


  @HostListener('window:beforeunload')
  canDeactivate(): any {
    if (this.ismanualclose || this.isviewmode) {
      return true;
    }
    else {
      return false;
    }
  }

  
  //Approvals POP
  fnShowApprovalPop(stauts) {

    const modalRef = this.productFindService.open(ApprovepopComponent, { size: <any>'l' });
    modalRef.componentInstance.formmode = stauts;
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.formid = this.leaveid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      if (receivedEntry === 'DONE') {
        this.fngetLeave();
      }


    });
  }

  
  

  //Attachment
  fnGetAttachmentCount() {
    if (this.leaveid > 0) {
      var data = {
        'trxid': this.leaveid,
        'trxtype': this.formname,
      }


      this.appService.fngetAttachmentCountDetails(data).subscribe(
        (res) => {
          if (res.json().status === 200) {
            var result = res.json().result;
            if (result.length > 0) {
              this.attachmentcount = result[0].attachmentcount
            }
          }
          else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        });
    }

  }

  

  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }
  fngetDescriptionRefno(data) {
    var rtnstr = "";
    try {
      if (data.transdt) {
        rtnstr = rtnstr + data.transdt;
      }

      if (data.empid) {
        rtnstr = rtnstr + " - " + data.empid;
      }

      if (data.empname) {
        rtnstr = rtnstr + " - " + data.empname;
      }
    } catch {

    }
    return rtnstr;
  }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc, companyid: this.loginService.fnGetCompanyId(),
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }
  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }







}
